module.exports = {
      id: "newlogo_L1-usage",
      viewBox: "0 0 60 34",
      url: __webpack_public_path__ + "svg-sprite-71cc17c6d762c8495e8a5375f2902e76.svg#newlogo_L1",
      toString: function () {
        return this.url;
      }
    }